import { jobWorkItemSlipDeleteApi } from "src/domain/api/jobWorkItem/slip/jobWorkItemSlipDeleteApi"

type PayloadShape = Parameters<typeof jobWorkItemSlipDeleteApi>[0]

export async function jobWorkItemSlipDeleteService(payload: PayloadShape, token: string) {
	return await jobWorkItemSlipDeleteApi(payload, token)
}
